import Pin from './Pin'

const PinConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: [],
	routes: [
		{
			path: '/pin',
			component: Pin
		}
	]
}

export default PinConfig
